import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import styles from './FAQs.module.css';

const SECTIONS = [
  {
    id: 'account',
    title: 'Account & Platform',
    items: [
      {
        q: 'What is Vox Pop?',
        a: (<><p>VoxPop is American Idol meets Kickstarter, but for indie film. We're all about putting the people (that's you) in control of what you watch, so Hollywood doesn't call the shots here. You do.</p><p>Watch trailers, vote with your wallet, and greenlight the original movies you want to see made into full-length films. Just don't get too drunk with power.</p></>),
      },
      {
        q: 'Is it free to create an account?',
        a: (<p>Free baby! When you sign up, it's free. Your vote (money) decides this election, whoops!<br />Didn't mean to get all political, scout's honor ✌✌</p>),
      },
      {
        q: 'How do I contact support?',
        a: (<p>Hit that contact button. We'll try to get back to you in 3 business days.</p>),
      },
    ],
  },
  {
    id: 'voting',
    title: 'Voting & Wallet',
    items: [
      {
        q: 'How does voting work?',
        a: (<p>Simple, $1 = 1 vote. Load up your wallet and vote to your heart's content. What you do with your computer, is none of our business….</p>),
      },
      {
        q: 'Can I vote more than once for the same trailer?',
        a: (<><p>Yup.</p><p><strong>AND - Voting 5+ times unlocks your ticket</strong> to see the completed film, and voting beyond that unlocks tiered rewards.</p></>),
      },
      {
        q: 'Do my funds expire?',
        a: (<p>No, just like a certain song from a certain movie, your funds will go on!</p>),
      },
      {
        q: 'Where does the money go?',
        a: (<><p>Straight into the movie. For real. When a project wins, we break down the budget line by line (casting, lighting, equipment, etc.), and the money goes directly into production.</p><p>VoxPop takes a small cut (our ramen noodles don't buy themselves), but if this were a cash grab, we'd charge way more.</p><p>We're here to launch films, and that's where your money goes.</p></>),
      },
      {
        q: 'What happens once a movie gets fully funded?',
        a: (<><p>So glad you asked. That's when the magic (and a bit of light chaos) begins. Think casting calls, craft services, location scouting, mild existential dread, and everything else that goes into producing a movie.</p><p>And then, the actual filmmaking. Once the movie's been shot, edited, and declared ready for prime time, it hits the VoxPop streaming lineup where you can watch it. Because if you voted, you helped make it happen.</p></>),
      },
      {
        q: 'Do you give refunds?',
        a: (<p>We hate to be that guy, but we're not Amazon. Every dollar you vote with is a vote for cinema. Even if your film doesn't win this round, your support helped bring it closer to reality. Our goal is to fund all the films on the site (also, refunds make the revolution messy).</p>),
      },
      {
        q: "What if a film doesn't meet its funding goal?",
        a: (<p>We only promote projects we believe in. Your votes stay with that film until you transfer them elsewhere or the film gets funded.</p>),
      },
      {
        q: 'What is the VoxPop Wallet?',
        a: (<p>The VoxPop Wallet is a secure digital wallet. Load it up to vote, unlock premium content, or collect bragging rights when your favorite film gets greenlit.</p>),
      },
      {
        q: 'How do I add funds to my Wallet?',
        a: (<p>Easy. Head to My Account → Wallet → Choose your payment method. Pick Apple Pay, Google Pay, your roommate's Venmo…. We've got options.</p>),
      },
      {
        q: 'Is my payment information secure?',
        a: (<p>Absolutely. We use only trusted third-party platforms with the kind of security that would make a heist movie jealous.</p>),
      },
    ],
  },
  {
    id: 'watching',
    title: 'Watching Films',
    items: [
      {
        q: 'How much does it cost to watch the winning film?',
        a: (<><p>That depends — how involved were you? If you voted at least five times for the winning film (that's $5 in votes), it's yours to watch for free.</p><p>If you didn't vote at least 5x, you pay the remaining difference. For example, if you only voted three times, you pay the difference ($2).</p><p>Didn't vote at all? It's up to $5 to stream it. (Still a steal.)</p></>),
      },
      {
        q: "I didn't vote for the winning film. Can I still watch it?",
        a: (<><p>Yes! And you've got options:</p><p><strong>1 – Move some money around:</strong><br />Transfer your votes from another film. If they add up to 5, you get to watch for free.<br />If not, you pay the difference. (This does take money away from the film you originally voted for, though!)</p><p><strong>2 – Stay loyal:</strong> Pay $5 to stream the winning movie and keep your loyalty to your first pick intact. Respect.</p></>),
      },
      {
        q: 'How do I access the library?',
        a: (<p>You need to have voted at least once on any active trailer. Once you've voted, the Library page becomes accessible and shows all films that have reached their goal or been released. Congrats, you did that! Treat yo self.</p>),
      },
    ],
  },
  {
    id: 'tiers',
    title: 'Rewards & Tiers',
    items: [
      {
        q: 'What are the reward tiers?',
        a: (<p>VoxPop has four reward tiers based on how many votes you cast on a specific project: <strong>Bronze</strong> (5+ votes), <strong>Silver</strong> (10+), <strong>Gold</strong> (25+), and <strong>Diamond</strong> (50+). The more you back a film, the more you unlock.</p>),
      },
      {
        q: 'What do I get with each tier?',
        a: (<p>Benefits vary by project and are published on each film's page before you vote. Expect things like complimentary streaming of the finished film (starting at Bronze), early access, director Q&amp;As, event invitations, and merch discounts that scale up through Silver, Gold, and Diamond. We use commercially reasonable efforts to deliver every advertised perk.</p>),
      },
      {
        q: 'Do tiers carry over between projects?',
        a: (<p>No — tiers are project-specific. Your Diamond status on one film doesn't automatically apply to the next. Each project is its own voting round with its own tier ladder.</p>),
      },
      {
        q: 'Can I lose my tier status?',
        a: (<p>Once you've earned a tier on a project, it's locked in. We won't retroactively reduce tier status you've already earned. If we ever update the tier structure for future projects, we'll give at least 30 days' notice.</p>),
      },
      {
        q: 'Can I transfer my tier status to someone else?',
        a: (<p>Tier status is personal to your account and can't be transferred, sold, or assigned. Your votes, your tiers.</p>),
      },
    ],
  },
  {
    id: 'filmmakers',
    title: 'Filmmakers',
    items: [
      {
        q: "I'm a filmmaker. How do I submit my film and become a creator on Vox Pop?",
        a: (<p>We love filmmakers! Glad you found us. To apply, just use our contact sheet. Drop us a line, and we'll get right back to you with more details. No ghosting, we promise!</p>),
      },
      {
        q: 'What kind of genres does VoxPop accept?',
        a: (<p>Everything….well except for adult entertainment. We're not that kind of site…yet. J/K!</p>),
      },
      {
        q: 'What happens if my film secures funding?',
        a: (<p>We'll match you with a professional production team to finalize the budget, keep things tight, and make sure the money goes where it should.</p>),
      },
      {
        q: 'Do I retain creative control of my film?',
        a: (<p>Absolutely. Your story will always be yours. We simply act as facilitators, connecting you to a production team with the funds to get it done.</p>),
      },
    ],
  },
];

function AccordionItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.item}>
      <button className={styles.question} onClick={() => setOpen(o => !o)}>
        <span>{q}</span>
        <span className={styles.indicator} style={{ background: open ? 'var(--white)' : 'var(--red)' }} />
      </button>
      {open && <div className={styles.answer}>{a}</div>}
    </div>
  );
}

export default function FAQs() {
  return (
    <div>
      <PageHeader title="faqs" />
      <div className={styles.page}>
        <div className={styles.pageHeader}>
          <h1 className={styles.bigTitle}>
            <span className={styles.bullet}>·</span> Frequently Asked Questions
          </h1>
          <p className={styles.subtitle}>
            The questions you're secretly wondering about but are too cool to ask
          </p>
        </div>
        <div className={styles.sections}>
          {SECTIONS.map(sec => (
            <div key={sec.id} className={styles.section}>
              <h2 className={styles.sectionTitle}>{sec.title}</h2>
              <div className={styles.items}>
                {sec.items.map((item, i) => (
                  <AccordionItem key={i} q={item.q} a={item.a} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
